/* istanbul ignore file */
import React from 'react';
import { VACANCY_STATUSES } from 'domain/recruiting/vacancy/shared/vacancyService';
import { EnumDropdown } from 'framework/form';

const VacancyStatusDropdown = (props: any) => {
  const options = { ...VACANCY_STATUSES };

  return <EnumDropdown options={options} label="Vacancy Status" placeholder="Choose Vacancy Status" {...props} />;
};

export default VacancyStatusDropdown;
